import { api } from "roboflex-thalamus-request-handler";
import { MachineInspectionModel } from "@/data/model/inspection/MachineInspectionModel";
import { AssetModel } from "@/data/model/AssetModel";
import { MachineInspectionParamModel } from "@/data/model/inspection/MachineInspectionParamModel";

export default {
  async getMachines() {
    let rawData = await api.get("ativos/listar");
    let machines = rawData.data.map((ele) => AssetModel.fromJson(ele));
    let isProd = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging";
    let filteredMachines = null;

    let prodCats = [314, 254, 246, 245, 244, 243, 242, 236, 235, 233, 231, 230, 229, 228, 227, 226, 413, 385, 444, 324];
    let devCats = [46, 40, 42];

    if (isProd) {
      filteredMachines = machines.filter((e) => {
        // let code = e.code.substring(4, 7);
        return prodCats.includes(e.categoriaId);
        // return code === "014" || code === "015";
      });
    } else {
      filteredMachines = machines.filter((e) => {
        // let code = e.code.substring(4, 7);
        // return code === "066";

        return devCats.includes(e.categoriaId);
      });
    }
    return filteredMachines;
  },

  async getParams() {
    let rawData = await api.get("parametro-ativo/listar");
    return rawData.data.map((ele) => MachineInspectionParamModel.fromJson(ele));
  },

  async getParamsForMachine(machine) {
    let rawData = await api.get(`ativos/${machine.id}/parametros`);
    return rawData.data.parametros.map((ele) => MachineInspectionParamModel.fromJson(ele || []));
  },

  async saveParamsForMachine(machine, params) {
    let content = {
      ativo_id: machine.id,
      parametro_id: params.map((e) => e.id),
    };
    await api.post("ativos/parametros/sincronizar", content);
  },

  async getInspections(paginacao, dtInicio, dtFim, page = 1, perPage = 30) {
    let content = { paginacao: paginacao };
    let isProd = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging";

    if (isProd) {
      content.categorias = "314,254,242,243,244,245,246,236,235,233,231,230,229,228,227,226,413,385,444,324";
    } else {
      content.categorias = "46,40,42";
    }

    if (dtInicio && dtFim) {
      content.dataInicio = new Date(dtInicio);
      content.dataFim = new Date(dtFim);
    }

    if (paginacao) {
      content.page = page;
      content.per_page = perPage;
    }

    let rawData = await api.get("ativos/inspecao/listar", { params: content });
    if (paginacao) {
      return {
        data: rawData.data.data.map((ele) => MachineInspectionModel.fromJson(ele)),
        pagination: {
          currentPage: rawData.data.current_page,
          lastPage: rawData.data.last_page,
          perPage: rawData.data.per_page,
          total: rawData.data.total,
          from: rawData.data.from,
          to: rawData.data.to,
          nextPageUrl: rawData.data.next_page_url,
          prevPageUrl: rawData.data.prev_page_url,
        },
      };
    } else {
      return rawData.data.map((ele) => MachineInspectionModel.fromJson(ele));
    }
  },

  async getSpecifInspection(inspection) {
    let rawData = await api.get(`ativos/inspecao/buscar/${inspection.id}`);

    return MachineInspectionModel.fromJson(rawData.data);
  },

  async createParam(paramName) {
    const content = { nome: paramName };
    let response = await api.post("parametro-ativo/gravar", content);
    return MachineInspectionParamModel.fromJson(response.data);
  },

  async downloadXlxs() {
    let file = await api.post("relatorio/inspecoes", { gerar: "xlsx" }, { responseType: "arraybuffer" });
    return file;
  },

  async downloadImg(img) {
    return await api.get(`anexo/download/${img.id}`);
  },

  async deletarInspecao(insp) {
    return await api.delete(`ativos/inspecao/deletar/${insp.id}`);
  },

  async getMachinesByCategories() {
    let categoriaIds = [314, 254, 242, 243, 244, 245, 246, 236, 235, 233, 231, 230, 229, 228, 227, 226, 413, 385, 444, 324];

    let content = { categoria_ids: categoriaIds };
    let rawData = await api.post("ativos/buscar-por-categorias", content);
    let machines = rawData.data.map((ele) => AssetModel.fromJson(ele));

    return machines;
  },
};
